import React, { useContext, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { RouteComponentProps } from "react-router";
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { ApplicationContext } from '@msx/platform-services'
import { messages } from './NotFound.messages';
import { getStyles } from './NotFound.styles';
import ErrorPage from '../../../../src/app/images/errorPage.svg';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { getOpportunityLink, isEmbeddedInDynamics } from '../../../core/utils';
import { ScrollablePane } from '@fluentui/react';
import { shellStyles } from '../../App.styles';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentAppState } from '../../../core/store';

const getClassNames = classNamesFunction<any, any>();
let classes: any;

interface OwnProps extends InjectedIntlProps {
  //TODO;
}

type NotFoundProps = OwnProps & InjectedIntlProps & RouteComponentProps;

const NotFoundComponent: React.FC<NotFoundProps> = props => {
  const { intl } = props;
  const { appState, extensionsRegistrationClient } = useContext(ApplicationContext);
  const reduxDispatch = useDispatch();
  const currentAppState = useSelector(getCurrentAppState);
  const allowExtensions = appState.appConfig.registrationConfig.active;

  classes = getClassNames(getStyles, appState.theme);
  const [redirectToHome, setRedirectToHome] = useState(false);

    useEffect(() => {
      let timeoutId;
      if (!redirectToHome) {
        setTimeout(() => {
          setRedirectToHome(true);
        }, 7000)
      }
      return () => {
        clearTimeout(timeoutId);
      }
    }, [redirectToHome]);

  const renderMain = (): JSX.Element => {

    if (appState.isUserLoggedIn && allowExtensions && extensionsRegistrationClient.getRoutes().length === 0)
      return null;
    return (
      <ScrollablePane className={isEmbeddedInDynamics() ? shellStyles.scrollablePaneEmbedded : (currentAppState.isNavCollapsed ? shellStyles.scrollablePaneCollapsed : shellStyles.scrollablePaneExpand)}>
        <div className={classes.test}>
          <img src={ErrorPage} className={classes.errorImage} alt={intl.formatMessage(messages.errorImageText)} />
          <h1 className={classes.headingMain}>{intl.formatMessage(messages.pageTile)}</h1>
          <h3 className={classes.description}>{intl.formatMessage(messages.pageDescription)}</h3>
          <PrimaryButton href={"/"}>{intl.formatMessage(messages.homePageButton)}</PrimaryButton>
          {/* <Link className={classes.homeLink} to="/">
            {intl.formatMessage(messages.homePage)}
          </Link> */}
        </div>
      </ScrollablePane>
    )
  }
  return renderMain();
}

export const NotFound = withRouter(injectIntl(NotFoundComponent));
